import { defineStore } from 'pinia'

import { type S3ImportParameters, importFromBucket, listBuckets } from '@/api'
import type { Bucket, UUID } from '@/types'

interface State {
  /**
   * S3 buckets that are available for imports.
   */
  buckets: { [key: Bucket['name']]: Bucket }
}

export const useIngestStore = defineStore('ingest', {
  state: (): State => ({
    buckets: {},
  }),
  actions: {
    async listBuckets() {
      const resp = await listBuckets()
      this.buckets = Object.fromEntries(resp.map((b) => [b.name, b]))
    },

    fromBucket(payload: S3ImportParameters): Promise<UUID> {
      return importFromBucket(payload)
    },
  },
})
